import { render, staticRenderFns } from "./AddPromotion.vue?vue&type=template&id=4ee9011c&scoped=true&"
import script from "./AddPromotion.vue?vue&type=script&lang=js&"
export * from "./AddPromotion.vue?vue&type=script&lang=js&"
import style0 from "./AddPromotion.vue?vue&type=style&index=0&id=4ee9011c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee9011c",
  null
  
)

export default component.exports